export const cardImages = [
  { src: '/png/Aubergine.png  ', matched: false },
  { src: '/png/Avocado.png', matched: false },
  { src: '/png/Lettuce.png', matched: false },
  { src: '/png/Lime.png', matched: false },
  { src: '/png/Pumpkin.png', matched: false },
  { src: '/png/Tomatoes.png', matched: false },
  { src: '/png/Walnuts.png', matched: false },
  { src: '/png/YellowPepper.png', matched: false },
];
